const header = document.getElementById("header");
const active = document.querySelector(".header--active");

active?.scrollIntoView({
  behavior: "smooth",
  block: "end",
  inline: "center",
});
